export default __webpack_public_path__ + "static/media/Screenshot_7.654f5f39.png";